"use strict";
/* Copyright (c) 2022 Xperi. All Rights Reserved. */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SageTransport = void 0;
var spark_md5_1 = __importDefault(require("spark-md5"));
var axios_1 = __importDefault(require("axios"));
var SageTransport = /** @class */ (function () {
    function SageTransport(params) {
        this.mSageTransportParams = params;
        this.mApiKey = this.generateAPIKey();
        this.mToken = this.generateToken();
    }
    SageTransport.prototype.generateAPIKey = function () {
        var apiKey = this.mSageTransportParams.appName.toString(16) +
            this.mSageTransportParams.deviceFamily.toString(16) +
            this.mSageTransportParams.os.toString(16) +
            this.mSageTransportParams.developmentPhase.toString(16);
        apiKey += ('00000000' + this.mSageTransportParams.partnerId.toString(16)).slice(-8);
        apiKey = apiKey.toUpperCase();
        return apiKey;
    };
    SageTransport.prototype.generateToken = function () {
        var spark = new spark_md5_1.default();
        spark.append(this.mSageTransportParams.tokenSalt);
        spark.append(this.mApiKey);
        return spark.end().toUpperCase();
    };
    SageTransport.prototype.send = function (sendable) {
        var _this = this;
        var payload = {
            time: Date.now(),
            event: sendable.toSendable(),
        };
        return new Promise(function (resolve, reject) {
            axios_1.default.post(_this.mSageTransportParams.hecEndpoint, payload, {
                headers: {
                    Authorization: 'Splunk ' + _this.mToken,
                    'Content-Type': 'application/json',
                },
                timeout: _this.mSageTransportParams.timeout || 5 * 1000,
            })
                .then(function () {
                resolve(true);
            })
                .catch(function (error) {
                // if network error
                // ERR_INTERNET_DISCONNECTED -> No Internet
                // ERR_NETWORK_CHANGED -> your internet is connected but not working
                // ERR_NAME_NOT_RESOLVED -> when connected to switch but removed the ethernet cable or when the DNS cannot find a site's IP address
                if (error.message === 'Network Error' ||
                    error.message === 'ERR_INTERNET_DISCONNECTED' ||
                    error.message === 'ERR_NETWORK_CHANGED' ||
                    error.message === 'ERR_NAME_NOT_RESOLVED') {
                    reject(false);
                }
                // for rest other errors
                else
                    reject(true);
                // throw err;
            });
        });
    };
    return SageTransport;
}());
exports.SageTransport = SageTransport;
